import { ReactNode } from 'react';
import {
    TbBrackets,
    TbCalendarEvent,
    TbCategory2,
    TbCheck,
    TbCoins,
    TbHash,
    TbLink,
    TbMail,
    TbMapPin,
    TbPercentage,
    TbPhone,
    TbTextCaption,
} from 'react-icons/tb';

type SchemaFieldIconInput = {
    icon?: ReactNode | string;
    type?: string;
};

type SchemaFieldIconKind = 'metric' | 'dimension';

export const getSchemaFieldIcon = (
    field: SchemaFieldIconInput | undefined,
    color: string,
    kind: SchemaFieldIconKind,
) => {
    if (field?.icon && typeof field.icon !== 'string') {
        return field.icon;
    }

    const type = field?.type?.toLowerCase() ?? '';
    const iconKey = typeof field?.icon === 'string' ? field.icon.toLowerCase() : '';
    const iconProps = { size: '75%', style: { color } };

    if (type.includes('percent') || iconKey.includes('percent') || iconKey.includes('return')) {
        return <TbPercentage {...iconProps} />;
    }

    if (type.includes('date') || type.includes('time') || iconKey.includes('date') || iconKey.includes('period')) {
        return <TbCalendarEvent {...iconProps} />;
    }

    if (type.includes('number') || type.includes('integer') || type.includes('float')) {
        return <TbHash {...iconProps} />;
    }

    if (type.includes('currency') || type.includes('money') || iconKey.includes('financial')) {
        return <TbCoins {...iconProps} />;
    }

    if (type.includes('boolean') || iconKey.includes('boolean') || iconKey.includes('check')) {
        return <TbCheck {...iconProps} />;
    }

    if (type.includes('json') || type.includes('object') || iconKey.includes('json')) {
        return <TbBrackets {...iconProps} />;
    }

    if (type.includes('url') || type.includes('link') || iconKey.includes('link')) {
        return <TbLink {...iconProps} />;
    }

    if (type.includes('email') || iconKey.includes('email')) {
        return <TbMail {...iconProps} />;
    }

    if (type.includes('phone') || iconKey.includes('phone')) {
        return <TbPhone {...iconProps} />;
    }

    if (type.includes('geo') || type.includes('location') || iconKey.includes('map')) {
        return <TbMapPin {...iconProps} />;
    }

    if (type.includes('string') || type.includes('text')) {
        return <TbTextCaption {...iconProps} />;
    }

    return kind === 'metric' ? <TbCoins {...iconProps} /> : <TbCategory2 {...iconProps} />;
};
